import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class MassStartClassGroupAssociationModel extends Model 
{
	@attr seedGroup;
	
	@belongsTo('classGroup', {inverse: null, async: true}) ClassGroupId;
	@belongsTo('start-timing-record', {inverse: null, async: true}) StartTimingRecordId;
}